import { render, staticRenderFns } from "./ClinicianPatientNav.vue?vue&type=template&id=6b360bf5"
import script from "./ClinicianPatientNav.vue?vue&type=script&lang=js"
export * from "./ClinicianPatientNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports